angular.module('vastdesk')
  .component('displayCreativePreview', {
    bindings: {
      width: '@',
      height: '@',
      landingPageUrlBase64: '@',
      customCodeBase64: '@'
    },
    template: require("../templates/displayCreativePreview.html"),
    controllerAs: '$displayCreativePreviewCtrl',
    controller: ['$element', '$scope', function($element, $scope) {

      var self = this;
      var resizeObserver;
      var destroyed = false;

      // landing page URL and custom code are passed base64-encoded since they can contain
      // arbitrary markup (quotes, tags, macros) that must survive Angular's attribute
      // interpolation and HTML attribute parsing untouched
      var decodeBase64 = function(b64) {
        if (!b64) { return ''; }
        try {
          var binary = window.atob(b64);
          var bytes = Uint8Array.from(binary, function(c) { return c.charCodeAt(0); });
          return new TextDecoder('utf-8').decode(bytes);
        } catch (e) {
          console.warn('displayCreativePreview: failed to decode base64', e);
          return '';
        }
      };

      var decodeCustomCode = function(b64, landingPageUrl) {
        var decoded = decodeBase64(b64);
        return decoded.split('{{CLICK_URL}}').join(landingPageUrl || '');
      };

      // Wrap the raw creative markup in a minimal document so it renders
      // in isolation inside the sandboxed iframe.
      var buildSrcdoc = function(customCode) {
        var reset = [
          "html, body { margin: 0; padding: 0; width: 100%; height: 100%; }",
          "body { overflow: hidden; }"
        ].join("\n");

        return [
          "<!doctype html>",
          "<html>",
          "<head>",
          "<meta charset='utf-8'>",
          "<style>" + reset + "</style>",
          "</head>",
          "<body>" + customCode + "</body>",
          "</html>"
        ].join("\n");
      };

      // Scale the natural-size iframe to fit the host width, never upscaling past 100%
      var fitToContainer = function() {
        if (!self.naturalWidth) { return; }

        var available = $element[0].clientWidth;
        var scale = Math.min(1, available / self.naturalWidth);
        var displayWidth = Math.round(self.naturalWidth * scale);

        // Only the host width drives scaling
        if (displayWidth === self.displayWidth) { return; }

        $scope.$applyAsync(function() {
          if (destroyed) { return; }
          self.scale = scale;
          self.displayWidth = displayWidth;
          self.displayHeight = Math.round(self.naturalHeight * scale);
        });
      };

      this.$onInit = function() {
        self.naturalWidth = parseInt(self.width, 10) || 0;
        self.naturalHeight = parseInt(self.height, 10) || 0;
        self.scale = 1;
        self.displayWidth = self.naturalWidth;
        self.displayHeight = self.naturalHeight;
      };

      this.$postLink = function() {
        // The custom-element host is display:inline by default, so it reports
        // no usable width. Make it a block that fills the column before we
        // measure against it.
        $element[0].style.display = 'block';

        // Assign srcdoc directly on the DOM node rather than via an Angular
        // binding so the decoded markup (which may contain {{ }}) is never run
        // through interpolation.
        var iframe = $element[0].querySelector('iframe');
        if (iframe) {
          var landingPageUrl = decodeBase64(self.landingPageUrlBase64);
          var customCode = decodeCustomCode(self.customCodeBase64, landingPageUrl);
          iframe.srcdoc = buildSrcdoc(customCode);
        }

        fitToContainer();

        if (window.ResizeObserver) {
          resizeObserver = new ResizeObserver(fitToContainer);
          resizeObserver.observe($element[0]);
        } else {
          $(window).on('resize.displayCreativePreview', fitToContainer);
        }
      };

      this.$onDestroy = function() {
        destroyed = true;
        if (resizeObserver) {
          resizeObserver.disconnect();
        } else {
          $(window).off('resize.displayCreativePreview', fitToContainer);
        }
      };

    }]
  });
